import { getRequest, type IValidatedResponse } from '../../httpClient';
import {
  getMovieTasteV1ResponseSchema,
  type IGetMovieTasteV1Response,
} from './get-movie-taste-v1-response';

export async function getMovieTasteV1Api(): Promise<IValidatedResponse<IGetMovieTasteV1Response>> {
  return getRequest<IGetMovieTasteV1Response>({
    path: '/account/movie-taste/v1',
    schema: getMovieTasteV1ResponseSchema,
  });
}
